// extracted by mini-css-extract-plugin
export default {"wrapper":"PrintResults_wrapper__qgBKH","printButton":"PrintResults_printButton__Exsdq"};